import { useQuery, UseQueryResult } from 'react-query';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';
import { SoldProductReportRow } from '../../../interfaces/soldProductReport.interface';

interface TopProductsForAdReport {
  hasNextPage: boolean;
  report: SoldProductReportRow[];
}

export const useGetTopProductsForAd = (
  identifier: string,
  adCode: string,
  from: Dayjs | null,
  to: Dayjs | null,
  page: number,
): UseQueryResult<ApiResponse<TopProductsForAdReport>, ApiError<TopProductsForAdReport>> => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'page', page.toString());
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery(
    [`reports_${queryKey}_${adCode}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}sold-products/top-products-for-ad/${adCode}?${queryParams}`),
    { enabled: !!adCode },
  );
};
